import ShopifyCartIcon from "@elem/compCommon/ShopifyCartIcon";
import ShopifyShoppingCart from "@elem/compCommon/ShopifyShoppingCart";
import { ShopifyCartItemType } from "@elem/compCommon/ShopifyShoppingCart/const";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export const useShoppingCart = () => {
    const [visible, setVisible] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [shoppingCarts, setShoppingCarts] = useState<ShopifyCartItemType[]>([]);
    const handleCallback = (carts: ShopifyCartItemType[], isClose?: boolean, target?: string) => {
        setShoppingCarts(carts);
        if (isClose) {
            setVisible(false);
        }
    };
    const handleAddCart = (cards: ShopifyCartItemType[]) => {
        setShoppingCarts((shopping) => {
            let result = JSON.parse(JSON.stringify(shopping));
            cards?.map((card: ShopifyCartItemType) => {
                const obj: ShopifyCartItemType = JSON.parse(JSON.stringify(card));
                const target = result.find((item: ShopifyCartItemType) => item?.productId === card?.productId && item?.variantId === card?.variantId);
                if (target) {
                    if (target.quantity >= target.inventory) return;
                    obj.quantity = target.quantity + 1;
                    result = [
                        obj,
                        ...result?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
                    ];
                } else {
                    obj.quantity = Number(obj?.inventory) > 0 ? 1 : 0;
                    result = [obj, ...result];
                }
            });
            return result;
        });
        setVisible(true);
    };
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
            const carts = window.sessionStorage.getItem('wave-3-portable-air-conditioner-shopping-cart');
            if (carts) {
                setShoppingCarts(JSON.parse(carts));
            }
        }
    }, []);

    /**
     * 检测变化，同步其他页面
     */
    useEffect(() => {
        if (typeof window !== 'undefined') {
           window.sessionStorage.setItem('wave-3-portable-air-conditioner-shopping-cart', JSON.stringify(shoppingCarts));
        }
    }, [shoppingCarts])

    return {
        Comp: <>
            {visible && isClient && createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}
            {isClient &&
                createPortal(
                    <ShopifyCartIcon
                        quantity={shoppingCarts.reduce((prev: number, curItem: ShopifyCartItemType) => {
                            return prev + Number(curItem.quantity);
                        }, 0)}
                        callback={() => setVisible(true)}
                    />,
                    document.body,
            )}
        </>,
        handleAddCart,
    }
}